// Fabricant data from Bible 09.02.2026 catalogue
// Maps project name (uppercase) to fabricant(s)
// Used as fallback when no manual fabricant is set on a piece

const BIBLE_FABRICANTS = {
    "002TDM TAVOLA DEI MARMI": "CUIVRINOX, PACO Marbrerie, Artefacts",
    "ABYSSE MONTE-CARLO": "Pietro Seminelli , Caroline Desile, Célia Bertrand, Silver Sentimenti",
    "AILE ET MOI": "Fermob",
    "ARGI": "Xavier Favaro, MENUISERIE ENTSIA",
    "CABRIOLET": "Romain Vigouroux, Design Guillaume Giraud",
    "CARTIER BOUTIQUE": "Atelier Cocoroca, TOLLIS Studio, Céramiques du Beaujolais, Laurentine Périlhou , Blundell & Therrien, Antonin Lamoot",
    "CASA COMPORTA": "Élitis",
    "CERCLE & TRAIT COLLECTION": "CVL Luminaires",
    "CEYSSON & BENETIÈRE GALLERY": "Atelier Moore, CarréSol Éditions, Laval, Issé, édition 1.6.9",
    "CHALET": "Fonderie d'Art Macheret, Cécile Gauneau et Anna Lucchini, Concept Ebenist', Pinton",
    "CHROME, BRICKS, PINE": "Antoine Lecreux, Aubier Studio, Atelier Lumierrante",
    "CLOUD": "Lamellux, Maison Chartier",
    "ÉCOLE DES ARTS JOAILLIERS": "Pierre Frey, Matière Grise, Versant",
    "ELIO": "Ligne Roset",
    "ENDLESS SUMMER II": "Maison Fey",
    "FERTILE LANDS": "Balsan",
    "FRANCE PAVILION – EXPO 2025 OSAKA": "Ligne Roset, Cinna, Lafuma Mobilier, Atelier Alain Ellouz, Duvivier Canapés, Sokoa, Disderot, DECOTEC, Tectona, Sèvres - Manufacture et Musée nationaux , Roger Pradier , Disderot",
    "GLORIA": "GWILEN",
    "GLYPHE & STROPHE": "Paul Demarquet",
    "ILLICO": "Ligne Roset",
    "ILLUSION": "Glass Variations",
    "INTOYO": "Yamina SARL",
    "KI": "ATL ébéniste",
    "LA LAMPE QUI VA DE SOIE": "Sericyne",
    "LA PERGOLA, ROME CAVALIERI, WALDORF ASTORIA": "Voyons Voir",
    "LE GRAND BALCONIE": "Tôlerie Forézienne",
    "LOUIS VUITTON APARTMENT": "MAISON AD, Pierre Frey",
    "LOUIS VUITTON VIC STORE": "Ateliers Berger, Sophie Mallebranche, Duval & Mauler",
    "MANDARIN ORIENTAL, MUSCAT": "Élitis, THG Paris",
    "MISTINGUETTE": "Furniture For Good",
    "MOB002.LA CABEÇ": "Léa Baldassari, Atelier Palouma",
    "MOBULA": "Coulon Tapissier",
    "MODULOIR": "CUIVRINOX, MAC MOBILIER",
    "MONTBLANC WATCHES & WONDERS EXHIBITION": "Centthor, Pettier agencement, MéMo, ATELIER PRAS",
    "NAPÉE": "Tizu",
    "NEOPHORE": "Alma Mater Céramiques",
    "OFFSIDE BAR": "Moustache, AdLucem, Trone, Élitis, Résistub Productions",
    "OLO": "SCHAFFNER, Laval, INATA",
    "ORACLE": "GOUDE GLASS, LG Tec",
    "ORIENT EXPRESS CORINTHIAN": "Remy Garnier, Atelier Rayssac, Rinck, Atelier Pictet, Ateliers Jouffre, Atelier Emmanuel Barrois, Atelier d'Offard, Agencement Paul Champs, Chauvet",
    "PECULIAR EROSION": "Fonderie Fusions",
    "PODIUM": "Sineu Graff",
    "POMO MUSEUM": "Pascal Michalon, CarréSol Éditions",
    "PRINTEMPS": "Atelier Julian Diaz, Atelier Roma",
    "PRISMA": "Marco Roy",
    "SQUEEZE VASES": "Cirva",
    "SWIING": "Fermob",
    "TOTEMIQUE": "Solum Lignum",
    "TUTTO SESTO": "FONTACHOULET, Tôlerie Forézienne",
    "VILLA": "Liaigre, Édtion 1.6.9, Zuber & Cie, Atelier Steaven Richard, Etienne Moyat, Horus, Créations Mourra, Marc Raimbault, Philippe Hurel, Série Rare, MILODINA\r\nAstropol, THG Paris, Atelier Jean Perzel, Objet Insolite",
    "WALDORF-ASTORIA": "Pierre Frey, Élitis",
};

export default BIBLE_FABRICANTS;
